import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Link } from "react-router-dom";
import { TrendingUp, TrendingDown, DollarSign } from "lucide-react";

export default function Forex() {
  const [pairs, setPairs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = () => api.get("/forex/pairs").then((r) => setPairs(r.data)).catch(() => {}).finally(() => setLoading(false));
    load();
    const interval = setInterval(load, 300000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="pt-10 pb-20">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <DollarSign className="w-8 h-8 text-yellow-400 mx-auto mb-4" />
          <h1 className="font-display font-bold text-4xl text-[var(--text-primary)]">Forex</h1>
          <p className="mt-3 text-[var(--text-secondary)]">Live exchange rates for major currency pairs, ECB-sourced.</p>
        </div>

        {loading ? (
          <p className="text-center text-[var(--text-tertiary)] font-mono text-sm">Loading rates...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {pairs.map((p) => {
              const slug = p.pair.replace("/", "-");
              const up = p.change_pct >= 0;
              return (
                <Link key={p.pair} to={"/forex/" + slug}
                  className="bg-[var(--bg-panel)] border border-[var(--border-soft)] rounded-xl p-5 hover:border-yellow-400/30 hover:-translate-y-0.5 transition">
                  <div className="flex items-center justify-between">
                    <span className="font-bold text-[var(--text-primary)]">{p.pair}</span>
                    {p.change_pct != null && (
                      <span className={"flex items-center gap-1 text-xs font-mono font-bold " + (up ? "text-green-400" : "text-red-400")}>
                        {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                        {up ? "+" : ""}{p.change_pct.toFixed(2)}%
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-[var(--text-tertiary)] mt-1">{p.name}</div>
                  <div className="font-display font-bold text-2xl text-[var(--text-primary)] mt-3">{p.rate?.toFixed(5) ?? "—"}</div>
                </Link>
              );
            })}
          </div>
        )}

        <p className="text-xs text-[var(--text-tertiary)] text-center mt-8">
          Rates sourced from the European Central Bank via Frankfurter. Daily reference rates, not live tick data. Not financial advice.
        </p>
      </div>
    </div>
  );
}